module.exports = __webpack_public_path__ + "img/order-pickup.84ba4868.png";